module.exports = __webpack_public_path__ + "static/mascon_wave_blink-2f19d613211db0f4e4e844e308ea4130.gif";